import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as Pubnub from 'pubnub';
import { Observable } from 'rxjs';
import { AppState } from 'src/store/appstate';
import { selectPubnubStatus } from 'src/store/pubnub/pubnub-store.model';

@Component({
  selector: 'tcs-pubnub-status',
  templateUrl: './pubnub-status.component.html',
  styleUrls: ['./pubnub-status.component.scss'],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PubnubStatusComponent {
  public status$: Observable<Pubnub.StatusEvent | null>;

  constructor(store: Store<AppState>) {
    this.status$ = store.select(selectPubnubStatus());
  }
}
